import { TenantSettingsPublicIntegrationsSaferpayDto } from './tenant-settings-public-integrations-saferpay.dto';

export class TenantSettingsPublicPaymentProvidersDto {
  isEnabled?: boolean | null;
  apiPaymentBaseUrl?: string | null;
  saferpay?: TenantSettingsPublicIntegrationsSaferpayDto | null;
}
